import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const OrbitIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M4.92891 19.0711C6.491 20.6332 10.9232 18.7337 14.8284 14.8284C18.7336 10.9232 20.6331 6.49102 19.071 4.92892C17.5089 3.36682 13.0768 5.26632 9.17155 9.17156C5.2663 13.0768 3.36681 17.509 4.92891 19.0711Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
    </BaseIcon>
  ),
);

OrbitIcon.displayName = 'OrbitIcon';
